import { render, staticRenderFns } from "./DisSy.vue?vue&type=template&id=0e96b5ca&scoped=true&"
import script from "./DisSy.vue?vue&type=script&lang=js&"
export * from "./DisSy.vue?vue&type=script&lang=js&"
import style0 from "./DisSy.vue?vue&type=style&index=0&id=0e96b5ca&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e96b5ca",
  null
  
)

export default component.exports